import {
  LOGIN_ROUTE_PATH,
  REGISTER_ROUTE_PATH,
} from "@const/route-paths.const";
import Link from "next/link";
import { useRouter } from "next/router";

const TabSelect = () => {
  const router = useRouter();
  let loginRoute = LOGIN_ROUTE_PATH;
  let registerRoute = REGISTER_ROUTE_PATH;
  if (router.isReady) {
    const resumePath = router.query.r as string;
    loginRoute = `${LOGIN_ROUTE_PATH}?r=${resumePath}`;
    registerRoute = `${REGISTER_ROUTE_PATH}?r=${resumePath}`;
  }

  return (
    <nav className="my-3 container">
      <div className="row text-center">
        <div className="d-block d-lg-none">
          <img
            src="/assets/images/topvalue-logo.png"
            alt="Logo Topvlaue"
            className="img-fluid"
          />
        </div>
        <Link href={loginRoute}>
          <a
            className={`col-6 ${
              router.asPath.includes(LOGIN_ROUTE_PATH) && "active"
            }`}
          >
            เข้าสู่ระบบ
          </a>
        </Link>
        <Link href={registerRoute}>
          <a
            className={`col-6 ${
              router.asPath.includes(REGISTER_ROUTE_PATH) && "active"
            }`}
          >
            สมัครสมาชิก
          </a>
        </Link>
      </div>
    </nav>
  );
};

export default TabSelect;
